// Capa de acceso a datos del módulo Categorías. jerarquía de un nivel
// (categoria_padre_id) existe en el esquema pero no se explota en esta UI
// — ver comentario de la tabla en 4.2 del doc de BD ("cambio barato de
// incluir ahora, costoso de agregar después"): el listado y el formulario
// de este módulo tratan todas las categorías como una lista plana.

import { supabaseClient } from '@plataforma/supabase-client';

import { obtenerEstadoSesion } from '../estado-sesion.js';

function empresaIdActual() {
  return obtenerEstadoSesion().claims.empresa_id;
}

export async function listarCategorias() {
  return supabaseClient()
    .from('categoria')
    .select('id, nombre, slug, descripcion, imagen_url, orden, estado, actualizado_en')
    .is('eliminado_en', null)
    .order('orden', { ascending: true });
}

/** @param {string} categoriaId */
export async function obtenerCategoria(categoriaId) {
  return supabaseClient()
    .from('categoria')
    .select('*, seo (*)')
    .eq('id', categoriaId)
    .is('eliminado_en', null)
    .single();
}

/**
 * @param {{ nombre: string, slug: string, descripcion?: string, imagen_url?: string, orden?: number }} datos
 */
export async function crearCategoria(datos) {
  return supabaseClient()
    .from('categoria')
    .insert({ ...datos, empresa_id: empresaIdActual() })
    .select()
    .single();
}

/**
 * @param {string} categoriaId
 * @param {object} cambios
 */
export async function actualizarCategoria(categoriaId, cambios) {
  return supabaseClient().from('categoria').update(cambios).eq('id', categoriaId).select().single();
}

/**
 * Eliminación lógica. El trigger `fn_reasignar_categoria_principal`
 * (ADR-0003) se encarga de reasignar la categoría principal de cualquier
 * producto que dependiera de esta, o despublicarlo si no queda ninguna
 * alternativa — nada de eso vive acá, es responsabilidad de la base de
 * datos, no del cliente.
 *
 * @param {string} categoriaId
 */
export async function eliminarCategoria(categoriaId) {
  return supabaseClient()
    .from('categoria')
    .update({ eliminado_en: new Date().toISOString() })
    .eq('id', categoriaId);
}

/** @param {string} seoId */
export async function actualizarSeoCategoria(seoId, cambios) {
  return supabaseClient().from('seo').update(cambios).eq('id', seoId).select().single();
}
